import projection from '../generated/pwd504f1.json';
import { AcceptanceManifest } from '../types';
export const pwd504f1AcceptanceManifest = projection as AcceptanceManifest;
